import { useCallback } from "react";
import { Search as SearchInput } from "@ui-kit/Search/Search";
import { SearchResult } from "@dto/SearchResult";
import { SearchOption } from "./SearchOption";
import { search } from "@store/services/search";
import { useAppDispatch } from "@store/store";
import { useNavigate } from "@hooks/useNavigate/useNavigate";
import { logInfo } from "@lib/logger";
import { createAnalyticsEvent } from "@lib/analytics";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";

import "./Search.css";

const Search = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowSize();

  const handleSearch = useCallback(
    async (value: string) => {
      try {
        const { data } = await dispatch(search.initiate({ term: value }));
        return data ?? [];
      } catch (error) {
        logInfo(error);
        return [];
      }
    },
    [dispatch],
  );

  const handleSelect = useCallback(
    (value: SearchResult) => {
      createAnalyticsEvent("SearchSelected", { id: value.value });
      navigate(value.value);
    },
    [navigate],
  );

  const optionRender = useCallback((option: { data: SearchResult }) => {
    return <SearchOption data={option.data} />;
  }, []);

  return (
    <SearchInput
      variant="rounded"
      onSearchChange={handleSearch}
      optionRender={optionRender}
      onSelect={handleSelect}
      width={isMobile ? "100%" : undefined}
    />
  );
};

export { Search };
